import React, { useRef, useState } from 'react'
import * as S from '../contact/Contact.styles'
import emailjs from '@emailjs/browser'
import WhatsappImage from '../images/contact/whatsapp.png'
import CorreoImage from '../images/contact/correo.png'
import UbicacionImage from '../images/contact/direccion.png'

const Contact = () => {

    window.addEventListener('scroll', function () {
        let animacionContact = document.getElementById("contact")
        let posicionOb3 = animacionContact.getBoundingClientRect().top
        let tamañoDePantalla = window.innerHeight / 1

        if (posicionOb3 < tamañoDePantalla) {
            animacionContact.style.animation = "fadeInProjects 1s .25s forwards"
        }
    })

    const [contactDates, setContactDates] = useState({
        name: "",
        email: "",
        message: "",
        checkedTerms: false,
    })

    const [emptyInput, setEmptyInput] = useState(false)
    const [successSendForm, setSuccessSendForm] = useState(false)
    const [errorSendForm, setErrorSendForm] = useState(false)

    const onSubmit = (e) => {
        //evitar cambio de pagina
        e.preventDefault()

        //validate form
        if (contactDates.name === "" || contactDates.email === "" || contactDates.message === "" || contactDates.checkedTerms === false) {
            setEmptyInput(true)
        } else {
            emailjs.sendForm(
                process.env.REACT_APP_EMAILJS_SERVICE_ID,
                process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
                form.current,
                process.env.REACT_APP_EMAILJS_PUBLIC_USER_ID
            )
                .then((result) => {
                    setSuccessSendForm(true)
                },
                    (error) => {
                        setErrorSendForm(true)
                    })
        }

        //send form
    }

    const form = useRef()

    return (
        <>
            <S.ContainerContact id='contact'>
                <S.Title>
                    ✉️Contact with me
                </S.Title>
                <S.ContainerForm>
                    <S.TitleResp>
                        ✉️Contact with me
                    </S.TitleResp>
                    {successSendForm ? (
                        <S.SuccessMessage>The form was sent succesfully</S.SuccessMessage>
                    ) : (
                        <S.Form onSubmit={onSubmit} ref={form}>
                            <S.InputForm placeholder='Your name' type='text' name='name' onChange={(e) => setContactDates({ ...contactDates, name: e.target.value })} value={contactDates.name} />
                            <S.InputForm placeholder='Your email' type='email' name='email' onChange={(e) => setContactDates({ ...contactDates, email: e.target.value })} value={contactDates.email} />
                            <S.TextArea placeholder='Write your message' name='message' onChange={(e) => setContactDates({ ...contactDates, message: e.target.value })} value={contactDates.message} />
                            <S.ContainerCondition>
                                <input type="checkbox" onChange={(e) => setContactDates({ ...contactDates, checkedTerms: e.target.checked })} />
                                <span>Accept the terms and conditions</span>
                            </S.ContainerCondition>
                            <S.Button type="submit">
                                Send
                            </S.Button>
                        </S.Form>
                    )}
                    {emptyInput && (
                        <p>You shoul fill all the inputs and accept terms.</p>
                    )}
                    {errorSendForm && (<S.TextError>There wasa an error, try it later</S.TextError>)}
                </S.ContainerForm>
                <S.Footer>
                    <S.WhatSapp>
                        <a href="http://wa.me/+5493571355102" target='__blank'>
                            <img src={WhatsappImage} alt="" />
                        </a>
                        <p>+5493571355102</p>
                    </S.WhatSapp>
                    <S.Correo>
                        <img src={CorreoImage} alt="" />
                        <p>adarbox@gmail.com</p>
                    </S.Correo>
                    <S.Direcc>
                        <img src={UbicacionImage} alt="" />
                        <p>Rosario Vera Peñaloza 197.</p>
                    </S.Direcc>
                </S.Footer>
            </S.ContainerContact>
        </>
    )
}




export default Contact